import { Component } from '@angular/core';

@Component({
  selector: 'app-common-side-navigation',
  templateUrl: './common-side-navigation.component.html',
  styleUrls: ['./common-side-navigation.component.scss'],
})
export class CommonSideNavigationComponent {}
